<template>
  <div>
    <div class="skuList">
      <el-dialog title="SKU列表" :visible.sync="dialogVisible" width="670">
        <div v-loading="tableDataLoading" element-loading-text="SKU列表拼命加载中" element-loading-spinner="el-icon-loading">
          <el-table :data="tableData" style="width: 100%" ref="childMultipleTable"
            @selection-change="handleSelectionChange" :row-key="getRowKeys">
            <el-table-column type="selection" :reserve-selection="true" width="50" v-show="skuType || skuType == 0">
            </el-table-column>
            <el-table-column label="序号" align="left" type=index width="50">
            </el-table-column>
            <el-table-column prop="skuname" label="SKU信息">
              <template slot-scope="scope">
                <div>{{ scope.row.skuname }}</div>
              </template>
            </el-table-column>
            <el-table-column
              :label="logintype !== 'KEFU' && bmcKefuid == '4581' ? 'AYI' : '标价'">
              <template slot-scope="scope" v-if="scope.row.skuprice">
                <span v-if="dictCodeShow == 'LZDVN'">
                  ₫
                </span>
                <span v-if="dictCodeShow == 'LZDSG'">
                  $
                </span>
                <span v-if="dictCodeShow == 'LZDID'">
                  Rp
                </span>
                <span v-if="dictCodeShow == 'LZDPH'">
                  ₱
                </span>
                <span v-if="dictCodeShow == 'LZDTH'">
                  ฿
                </span>
                <span v-if="dictCodeShow == 'LZDMY'">
                  RM
                </span>
                <span
                  v-if="dictCodeShow != 'LZDMY' && dictCodeShow != 'LZDTH' && dictCodeShow != 'LZDPH' && dictCodeShow != 'LZDID' && dictCodeShow != 'LZDSG' && dictCodeShow != 'LZDVN'">
                  ¥
                </span>
                {{ scope.row.skuprice.toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column
              :label="logintype !== 'KEFU' && bmcKefuid == '4581' ? 'ADI' : '到手价'">
              <template slot-scope="scope" v-if="scope.row.availableprice">
                <span v-if="dictCodeShow == 'LZDVN'">
                  ₫
                </span>
                <span v-if="dictCodeShow == 'LZDSG'">
                  $
                </span>
                <span v-if="dictCodeShow == 'LZDID'">
                  Rp
                </span>
                <span v-if="dictCodeShow == 'LZDPH'">
                  ₱
                </span>
                <span v-if="dictCodeShow == 'LZDTH'">
                  ฿
                </span>
                <span v-if="dictCodeShow == 'LZDMY'">
                  RM
                </span>
                <span
                  v-if="dictCodeShow != 'LZDMY' && dictCodeShow != 'LZDTH' && dictCodeShow != 'LZDPH' && dictCodeShow != 'LZDID' && dictCodeShow != 'LZDSG' && dictCodeShow != 'LZDVN'">
                  ¥
                </span>
                {{ scope.row.availableprice.toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="状态" width="80">
              <template slot-scope="scope">
                <div v-if="scope.row.skuislowprice || scope.row.skuavailableislowprice"
                  style="background-color: red;width: 20px;height: 20px;color: white;text-align: center;line-height: 20px;border-radius: 20px;">
                  低
                </div>
                <img :src='require("@/assets/img/other/zhiwen-status.png")' alt="" class="zhiwen_status"
                  v-show="scope.row.ischange == '是'">
              </template>
            </el-table-column>
            <el-table-column prop="name" label="产品" width="250">
              <template slot-scope="scope">
                <div class="productname">
                  <span v-if="scope.row.productid">
                    <span v-if="scope.row.productid.length > 20">
                      {{ scope.row.productname }}
                    </span>
                    <span v-else>
                      限价标准：¥{{ scope.row.productid }}
                    </span>
                  </span>

                  <!-- {{scope.row.productname}} -->
                  <el-popover placement="top-start" width="200" trigger="hover" v-show="scope.row.productname">
                    <div>
                      <div v-for="item in $options.filters.objToAr(scope.row.price)" :key="item.name">
                        <div>{{ item.name }}:{{ item.val }}</div>
                      </div>
                    </div>
                    <i class="el-icon-warning-outline" slot="reference"></i>
                  </el-popover>
                  <i class="el-icon-edit-outline" style="color: #409eff;" @click="markingClick(scope.row)"></i>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer" v-if="skuType || skuType == 0">
          <el-button type="primary" @click="setUser" size="mini">确 定</el-button>
          <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        </span>
      </el-dialog>

    </div>
    <!-- 打标 -->
    <!-- <el-dialog title="打标" :visible.sync="markingShow" width="460px" size="small">
      <el-form class="search-form">

        <el-form-item label="AI推荐打标：" :label-width="formLabelWidth" v-if="aiData.length != 0">
          <div v-for="(item, index) in aiData" :key="index" :class="item.productid == aiId ? 'aiChangeStyle' : 'aiStyle'" @click="clickAi(item)">
            {{ item.productname }}
          </div>
        </el-form-item>
        <el-form-item label="打标设置：" :label-width="formLabelWidth">
          <el-cascader filterable clearable v-model="changeProductid" :options="options2"
            :props="productidChildren2" collapse-tags style="width: 100%;" @change="noClickAi"></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="confire_btn" size="small" @click="updateSkuProductid">确 定</el-button>
        <el-button @click="markingShow = false" size="small" type="cancel_blue">取 消</el-button>
      </span>
    </el-dialog> -->
    <batchMarkingChild type="sku" :platform="platform" ref="batchMarkingChild" @parent-method="childClickfat">
    </batchMarkingChild>
  </div>

</template>

<script>
import pagination from "../../../components/dataTable/pagination";
import batchMarkingChild from "./batchMarkingChild";
import aes from '@/libs/aes'
export default {
  name: "skuList",
  data: function () {
    return {
      tableDataLoading: false,
      tableDataAll: [],
      dialogVisible: false,
      tableData: [],
      paginae: {
        currentPage: 1,
        pageSizes: [10, 20, 30, 40],
        total: 40
      },
      sku: [],
      itemid: [],
      price: '',
      availableprice: '',
      discountchange: '',
      changeProductid: [],
      options2: [],
      productidChildren2: {
        value: "id",
        label: "productClassifyName",
        children: "children"
      },
      platform: '',
      itemtitle: '',
      skuLiData: [],
      logintype: '',
      bmcKefuid: '',
    }
  },
  props: {
    dictCodeShow: '',
    skuType: Number,
    skuids: String,
  },
  mounted() {

  },
  methods: {
    childClickfat() {
      this.getSkuList(this.skuLiData)
    },
    markingClick(data) {
      this.$refs.batchMarkingChild.startChange(data.skuId, data.numId, data.id)
    },
    getSkuList(skuData) {
      let newUrl = "hcm/iprNewPluginList/getSkuList"
      console.log(skuData,'skuData')
      if (skuData) {
        this.skuLiData = skuData
        this.platform = skuData.platform
        if (skuData.itemtype && skuData.itemtype == 2) {
          newUrl = "hcm/iprKeywordSearch/getIprKeywordSearchSkuList"
        }
      }
      this.itemtitle = skuData.itemtitle
      if (skuData.price && skuData.priceType == 1) {
        this.price = "标价" + skuData.price
      } else {
        this.price = ""
      }
      if (skuData.availableprice && skuData.priceType == 2) {
        this.availableprice = "到手价" + skuData.availableprice
      } else {
        this.availableprice = ""
      }
      if (skuData.discountchange) {
        this.discountchange = "_优惠券" + skuData.discountchange
      } else {
        this.discountchange = ""
      }
      this.tableDataLoading = true
      fetch({
        url: newUrl, method: "get", params: skuData,
      })
        .then((res) => {
          if (res.status == '10000') {
            this.tableData = []
            this.tableData = res.data.content
            this.tableDataLoading = false
          } else {
            this.$message({
              message: res.message,
              type: "error"
            });
          }
        }).catch((res) => {
          this.$message.error("请求出错！");
          this.tableDataLoading = false
        })
    },
    dialogVisibleShow(itemid) {
      this.logintype = JSON.parse(localStorage.getItem("userData")).logintype;
      this.bmcKefuid = JSON.parse(localStorage.getItem("userData")).bmcid;
      if (itemid) {
        this.itemid = itemid
      }
      this.dialogVisible = !this.dialogVisible
    },
    getSkuData(skuids) {
      if (skuids) {
        let ids = skuids.split(',')
        const { tableData } = this
        ids.forEach(key => {
          tableData.forEach(row => {
            if (row.skuId == key) {
              this.$refs.childMultipleTable.toggleRowSelection(row, true);
            }
          })
        })
      } else {
        this.$refs.childMultipleTable.clearSelection();
      }
    },
    handleSelectionChange(data) {
      this.sku = []
      for (let a in data) {
        this.sku.push({
          itemid: data[a].numId,
          skuid: data[a].skuId,
          name: this.itemtitle + '_' + data[a].skuname + '_' + this.price + "_" + this.availableprice + this.discountchange
        })
      }
    },
    getRowKeys(row) {
      return row.skuId
    },
    setUser() {
      let a = {}
      let b = this.deWeightThree()
      a.itemid = this.itemid
      a.sku = b
      this.$emit('childChange', a)
      this.dialogVisible = false
    },
    // 数组对象去重
    deWeightThree() {
      let name = 'name';
      let map = new Map();
      for (let item of this.sku) {
        if (!map.has(item.name)) {
          map.set(item.name, item);
        }
      }
      return [...map.values()];
    },
  },
  components: { pagination, batchMarkingChild },
  filters: {
    bjBigSmall: aes.bjBigSmall,
    objToAr: aes.objToArr
  },
}
</script>

<style lang="scss">
$ts: #faad14;
$blue: #409EFF;

.test_low_price {
  .popper__arrow:after {
    border-bottom-color: $ts !important;
  }

  .popper__arrow {
    border-bottom-color: $ts !important;
  }

  .el-tooltip__popper.is-dark {
    background: $ts;
  }
}

.skuList {
  .skuname {
    color: $blue;
  }

  .bottom_page .el-pagination {
    padding: 20px 0 0 0;
  }

  .el-dialog {
    height: 680px;
  }

  .el-table--fit {
    height: 530px;
    overflow-y: auto;
    width: 100%;
  }

  .zhiwen_status {
    width: 20px;
    height: 20px;
  }
}
</style>
